import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const { CONFIG } = require("../../config");

export const locusBaseQuery = async (args, WebApi, extraOptions) => {
  let { clientId, authToken } = args;
  const baseUrl = CONFIG.LOCUS?.[clientId]?.LOCUS_PROD_BASE_URL;

  const rawBaseQuery = fetchBaseQuery({
    baseUrl: `${baseUrl}/v1/client/${clientId}`,
    prepareHeaders: (headers) => {
      // headers.set("authorization", `${authToken}`);
      if (authToken) {
        headers.set("authorization", `Bearer ${authToken}`);
      }
      return headers;
    },
  });

  return rawBaseQuery(args, WebApi, extraOptions);
};

export const taxyApis = createApi({
  baseQuery: locusBaseQuery,
  endpoints: (builder) => ({
    createLocations: builder.mutation({
      query: (data) => {
        let { clientId, authToken, requestBody } = data;
        return {
          url: "location",
          method: "POST",
          body: requestBody,
          clientId,
          authToken,
        };
      },
    }),
    getHomebases: builder.mutation({
      query: (data) => {
        let { clientId, authToken, requestBody } = data;
        return {
          url: "homebase-master-search",
          method: "POST",
          body: requestBody,
          clientId,
          authToken,
        };
      },
    }),
    createRouteManifest: builder.mutation({
      query: (data) => {
        let { clientId, authToken, requestBody } = data;
        return {
          url: "route-master",
          method: "POST",
          body: requestBody,
          clientId,
          authToken,
        };
      },
    }),
    validateEntityIds: builder.mutation({
      query: (data) => {
        let { clientId, authToken, requestBody } = data;
        return {
          url: "entitytype/LOCATION/validateids",
          method: "POST",
          body: requestBody,
          clientId,
          authToken,
        };
      },
    }),
  }),
});

export const {
  useCreateLocationsMutation,
  useGetHomebasesMutation,
  useCreateRouteManifestMutation,
  useValidateEntityIdsMutation,
} = taxyApis;
